// extracted by mini-css-extract-plugin
export default {"QuestionViewPage":"QuestionViewPage_QuestionViewPage__V8WAZ"};